import {Component, Inject, OnInit} from '@angular/core';
import {APP_OPTIONS, AppOptions, BRAND_OPTIONS, BrandOptions} from '@unleashed/common/config';

@Component({
  selector: 'ua-salesforce-chat',
  templateUrl: './salesforce-chat.component.html',
  styleUrls: ['./salesforce-chat.component.scss']
})
export class SalesforceChatComponent implements OnInit {
  showChat = false;

  private readonly chatConfig: { orgId: string; deploymentName: string; siteUrl: string; scrt2URL: string } | undefined;

  constructor(
    @Inject(BRAND_OPTIONS) brandOptions: BrandOptions,
    @Inject(APP_OPTIONS) appOptions: AppOptions,
  ) {
    this.showChat = brandOptions.showChat;
    this.chatConfig = appOptions.chatConfig;
  }

  ngOnInit(): void {
    if (this.showChat && this.chatConfig) {
      this.loadEnhancedChatScript();
    }
  }

  private loadEnhancedChatScript(): void {
    if (!this.chatConfig) {
      console.error('Error loading chatbot: chatConfig not defined');
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = `${this.chatConfig.siteUrl}/assets/js/bootstrap.min.js`;
    script.onload = () => this.initEmbeddedMessaging();
    script.onerror = () => console.error('Error loading Enhanced Chat script');

    document.body.appendChild(script);
  }

  private initEmbeddedMessaging(): void {
    if (!this.chatConfig) {
      console.error('Error initializing chatbot: chatConfig not defined');
      return;
    }

    try {
      // @ts-ignore
      embeddedservice_bootstrap.settings.language = 'en_US';

      // @ts-ignore
      embeddedservice_bootstrap.init(
        this.chatConfig.orgId,
        this.chatConfig.deploymentName,
        this.chatConfig.siteUrl,
        {
          scrt2URL: this.chatConfig.scrt2URL
        }
      );
    } catch (err) {
      console.error('Error initializing chatbot: ', err);
    }
  }
}
